// extracted by mini-css-extract-plugin
export default {"QuickAsystIcon":"QuickAsystLogo_QuickAsystIcon__cSZsO"};